import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useCallback, useState } from "react";
import { CSVLink } from "react-csv";
import { debounce } from "../../../../../utils";
import "../../../../Admin/Reports/Reports Detailed/ReportsDetailed.css";
import { BreadcrumbAdmin } from "../../../../UI/BreadcrumbAdmin";
import DateRangePickerComp from "../../../../UI/DateRangePicker";
import { Search } from "../../../../UI/Search/Search";
import { BookSummaryTable } from "./BookSummaryTable";
import { useOutsideClick } from "../../../../../hooks/useOutsideClick";

const list = [
  {
    name: "depName",
    label: "Department Name",
  },
  { name: "hod", label: "Department HOD" },
  { name: "bookName", label: "Book Name" },
  { name: "bookCreator", label: "Book Creator" },
  { name: "totalLevels", label: "Total Levels" },
  { name: "totalTasks", label: "Total Tasks" },
  { name: "pointsAssigned", label: "Points Assigned" },
];

export const BookSummary = () => {
  const [select, setSelect] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [dateRange, setDateRange] = React.useState(null);

  const ref = React.useRef(null);

  const closePopup = () => {
  setSelect(false);
  };

  useOutsideClick(ref, closePopup);

  const [check, setCheck] = useState({
    depName: true,
    hod: true,
    bookName: true,
    bookCreator: true,
    totalLevels: true,
    totalTasks: true,
    pointsAssigned: true,
  });

  const base = [
    {
      _id: 1,
      link: "/super-admin/reports",
      label: "Reports",
    },
  ];

  const setDebouncedSearchQuery = useCallback(
    debounce((value) => {
      setSearchQuery(value);
    }, 500),
    []
  );

  const handleChange = (e) => {
    setCheck({ ...check, [e.target.name]: e.target.checked });
  };

  return (
    <div className="container">
      <BreadcrumbAdmin
        base={base}
        page={'Department Book Summary'}
      />
      <div className="reportsDetailed__head">
        <Search
          mini
          setSearchVal={(val) => setDebouncedSearchQuery(val)}
          placehold={'Search...'}
        />
        <div className="reportsDetailed__headright">
          <DateRangePickerComp
            onChange={(value) => {
              if (!value) {
                setDateRange(null);
              } else {
                setDateRange(value.map((val) => new Date(val).toISOString()));
              }
            }}
          />
          <div ref={ref} className="reports__selectLayout">
            <Button
              variant="outlined"
              endIcon={
                <ArrowForwardIosIcon
                  sx={{
                    transform: select ? 'rotate(-90deg)' : 'rotate(90deg)',
                    color: 'grey',
                    fontSize: '16px !important',
                  }}
                />
              }
              sx={{
                color: 'var(--grey400)',
                borderColor: 'var(--grey300)',
                width: '150px',
                fontWeight: '400 !important',
              }}
              onClick={() => setSelect(!select)}>
              Manage Field
            </Button>
            <div
              className={select ? 'reports__selectActive' : 'reports__select'}>
              <div className="reports__selectcontent">
                {list.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        defaultChecked={item.name}
                        name={item.name}
                        onChange={handleChange}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: '20px' } }}
                      />
                    }
                    onChange={handleChange}
                    label={
                      <span style={{ fontSize: '15px' }}>{item.label}</span>
                    }
                  />
                ))}
              </div>
            </div>
          </div>
          <CSVLink
            filename="Book summary"
            data={csvData}>
            <Button
              variant="contained"
              endIcon={<FileUploadOutlinedIcon sx={{ color: 'white' }} />}>
              Export
            </Button>
          </CSVLink>
        </div>
      </div>

      <div className="reports__table">
        <BookSummaryTable
          check={check}
          searchQuery={searchQuery}
          startDate={dateRange && dateRange[0]}
          endDate={dateRange && dateRange[1]}
          getTableData={(data) => {
            let cleanedCSVData = data?.data?.map((obj) => {
              let d = {
                'Department name': obj?.department?.name,
                'Department HOD':
                  obj?.department?.hod?.fname && obj?.department?.hod?.lname
                    ? `${obj?.department?.hod?.fname} ${obj?.department?.hod?.lname}`
                    : obj?.department?.hod?.email,
                'Book name': obj.name,
                'Book creator':
                  obj?.createdBy?.fname && obj?.createdBy?.lname
                    ? `${obj?.createdBy?.fname} ${obj?.createdBy?.lname}`
                    : obj?.createdBy?.email,
                'Total levels': obj.levelCount,
                'Total tasks': obj.tasksCount,
                'Points assigned': obj.points,
              };
              return d;
            });
            setCsvData(cleanedCSVData);
          }}
        />
      </div>
    </div>
  );
};
